module.exports = __webpack_public_path__ + "img/pro_s2_icon3.89294a8f.png";